<template>
    <va-create-layout>
        <ProductAdsPaymentEvent-form
            :title="title"
            :item="item"
        ></ProductAdsPaymentEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
